import { R } from '@core/utils/r';

interface AppConfig {
  BUILD_MODE: 'dev' | 'production';
  BUILD_ENV: string;

  IS_DEV: boolean;

  GC_API_URL: string;
  GC_URL: string;
  GC_SHORT_URL: string;
  GC_SHORT_URL_CAL: string;

  GC_S98_TENANT: string;
  PUSHER_KEY: string;

  DEV_USERNAME?: string;
  DEV_PASSWORD?: string;

  IS_ADMIN: boolean;
  GOOGLE_MAP_API: string;
  // IS_STAGE: boolean;
}

export const Config: AppConfig = process.env.BUILD_CONFIG as any;

Config.BUILD_MODE = process.env.BUILD_MODE as any;
Config.BUILD_ENV = process.env.BUILD_ENV as any;

Config.IS_DEV = Config.BUILD_MODE === 'dev';
Config.GOOGLE_MAP_API = Config.GOOGLE_MAP_API || '';
Config.GC_URL = document.location.origin || Config.GC_API_URL;
Config.IS_ADMIN = R.toString(Config.IS_ADMIN) === 'true';
// Config.IS_STAGE = R.toString(Config.IS_STAGE) === 'true';
